import { render, staticRenderFns } from "./formList.vue?vue&type=template&id=018e5950&scoped=true"
import script from "./formList.vue?vue&type=script&lang=js"
export * from "./formList.vue?vue&type=script&lang=js"
import style0 from "./formList.vue?vue&type=style&index=0&id=018e5950&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018e5950",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('018e5950')) {
      api.createRecord('018e5950', component.options)
    } else {
      api.reload('018e5950', component.options)
    }
    module.hot.accept("./formList.vue?vue&type=template&id=018e5950&scoped=true", function () {
      api.rerender('018e5950', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goodsManage/correct/components/formList.vue"
export default component.exports